import { Stack } from "@mui/material";

import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedAdditionalQuestionsForTicketProps = {
  itemType: "ticket" | "item" | "membership";
  purchasedAmount: number;
  groupNumber: number;
  participantNumber: number;
  isPartOfGroupTicket: boolean;
  children: React.ReactNode;
};

export const ThemedAdditionalQuestionsForTicket = ({
  purchasedAmount,
  itemType,
  isPartOfGroupTicket,
  groupNumber,
  participantNumber,
  children,
}: ThemedAdditionalQuestionsForTicketProps) => {
  const { t } = useTranslate();

  const formCategoryLabel = itemType === "item" ? t("ticketing", "item") : t("ticketing", "ticket");

  const getTicketHeaderLabel = () => {
    if (purchasedAmount > 1) {
      if (isPartOfGroupTicket) {
        return `${t("ticketing", "groupTicket")} ${groupNumber} - ${formCategoryLabel} #${participantNumber}`;
      } else {
        return `${formCategoryLabel} #${groupNumber}`;
      }
    }

    if (isPartOfGroupTicket) {
      return `${formCategoryLabel} #${participantNumber}`;
    }

    return "";
  };

  const ticketHeaderLabel = getTicketHeaderLabel();

  return (
    <Stack data-test="questions-one-group" gap={1}>
      {ticketHeaderLabel && (
        <FormTypography variant="subtitle2" vibe="supershy">
          {ticketHeaderLabel}
        </FormTypography>
      )}
      <Stack gap={2}>{children}</Stack>
    </Stack>
  );
};
